import React, { useState } from "react";

import { LivePanel } from "@demo/ui/LivePanel.js";
import { HeroPanel } from "@demo/ui/HeroPanel.js";
import { CLINICAL_GIG_CATALOG } from "@demo/live/gig-catalog-clinical.js";
import { VERALTA } from "./scenario/veralta.js";
import { CLINIC_BUNDLES } from "./data.js";

// The Veralta app now leads with an Overview (the two-card verify hero + the
// process strip, mirroring Torbridge), with the live seal behind a second tab.
// Everything below the masthead is shared UI driven by Veralta's copy; the
// recorded receipts the Overview verifies are two real prior-auth packages
// (apps/clinic-demo/src/data.ts).
type Mode = "hero" | "live";

export function App() {
  const [mode, setMode] = useState<Mode>("hero");

  return (
    <div className="page">
      <div className="disclosure-banner" role="note">
        <span className="disclosure-dot" aria-hidden="true" />
        <span>{VERALTA.disclosure}</span>
      </div>

      <header className="masthead">
        <div className="brand">
          <span className="brand-mark" aria-hidden="true">
            {VERALTA.client.mark}
          </span>
          <div>
            <div className="brand-name">{VERALTA.client.name}</div>
            <div className="brand-domain">{VERALTA.client.domain}</div>
          </div>
        </div>
        <div className="masthead-tag">{VERALTA.masthead}</div>
      </header>

      <div className="mode-toggle" role="tablist" aria-label="Demo section">
        <button
          role="tab"
          aria-selected={mode === "hero"}
          className={"mode-toggle-btn" + (mode === "hero" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("hero")}
        >
          Overview
        </button>
        <button
          role="tab"
          aria-selected={mode === "live"}
          className={"mode-toggle-btn" + (mode === "live" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("live")}
        >
          Run live
        </button>
      </div>

      {mode === "hero" ? (
        <main className="content">
          <HeroPanel
            hero={VERALTA.hero}
            flow={VERALTA.flow}
            bundles={CLINIC_BUNDLES}
            ctas={[{ ...VERALTA.liveCta, onClick: () => setMode("live") }]}
          />
        </main>
      ) : (
        <main className="content">
          <section className="intro">
            <h1>{VERALTA.intro.headline}</h1>
            <p>{VERALTA.intro.body}</p>
          </section>

          <LivePanel catalog={CLINICAL_GIG_CATALOG} copy={VERALTA.live} />
        </main>
      )}

      <footer className="footer">
        <p>
          {VERALTA.disclosure} Built on <span className="footer-link">{VERALTA.product.name}</span>:{" "}
          {VERALTA.product.tagline}.
        </p>
      </footer>
    </div>
  );
}
